import React, { useState } from 'react';
import { Menu, Card, Select, Divider, Button, Row, Col, Modal } from 'antd';
import axios from 'axios';
import 'antd/dist/antd.css';

import { instanceAxios } from '../../InstanceAxios';
import { XMEI_PRIMARY_COLOR, UFS } from '../../consts/common';

const { Option } = Select;

export default function Validacao() {
  const [itemMenu, setItemMenu] = useState('nfe');
  const [UF, setUF] = useState('');
  const [city, setCity] = useState('');
  const [arrayCities, setArrayCities] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChangeState = (value) => {
    setUF(value);
    getCities(value);
  };

  const contentRender = () => {
    switch (itemMenu) {
      case 'nfe':
        return (
          <Card>
            <Card type="inner" title="Município Homologado">
              <Divider orientation="left" plain>
                Estado
              </Divider>
              <Select
                style={{ width: '100%' }}
                value={UF}
                onChange={handleChangeState}
              >
                {UFS.map((estado) => (
                  <Option key={estado} value={estado}>
                    {estado}
                  </Option>
                ))}
              </Select>
              <Divider orientation="left" plain>
                Municípios
              </Divider>
              <Select
                showSearch
                value={city}
                style={{ width: '100%' }}
                optionFilterProp="children"
                onChange={(value, option) => {
                  setCity(value);
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {arrayCities.map((city) => (
                  <Option
                    key={city.id}
                    value={`${city.id}|${city.municipio.id}`}
                  >
                    {city.nome}
                  </Option>
                ))}
              </Select>
              <Row>
                <Col span={8} />
                <Col span={8}>
                  <Button
                    loading={loading}
                    style={{
                      width: '100%',
                      marginTop: 20,
                      backgroundColor: XMEI_PRIMARY_COLOR,
                      color: '#FFF',
                      height: 45,
                    }}
                    onClick={() => getStatusHomologation()}
                  >
                    CONSULTAR
                  </Button>
                </Col>
                <Col span={8} />
              </Row>
            </Card>
          </Card>
        );
      default:
        break;
    }
  };

  const getCities = async (uf) => {
    const response = await axios.get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/distritos`
    );

    setArrayCities(response.data);
  };

  const getStatusHomologation = async () => {
    setLoading(true);
    const ibge = city.split('|')[1];
    const response = await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/verificarStatusHomologacaoPrefeitura/${ibge}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {});

    if (!response) {
      Modal.error({
        title: 'Houve um erro de comunicação, tente novamente mais tarde.',
      });
      return;
    }

    if (response.message.includes('Não')) {
      Modal.warning({
        title: 'Município não homologado.',
      });
    } else {
      Modal.success({
        title: 'Município homologado.',
      });
    }

    setLoading(false);
    setUF('');
    setCity('');
  };

  return (
    <div style={{ margin: 20 }}>
      <Menu
        onClick={(e) => {
          setItemMenu(e.key);
        }}
        selectedKeys={[itemMenu]}
        mode="horizontal"
      >
        <Menu.Item key="nfe" style={{ color: '#000' }}>
          Emissão NF
        </Menu.Item>
      </Menu>
      {contentRender()}
    </div>
  );
}
